//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { ProductType } from '@models/IItemMetadata';
import { TrackingId, TrackingIdPrefix } from '@models/TrackingId';

export enum ProductResultsTypes {
  CATALOG_RESULTS = 'catalog-results',
  CATALOG_SUGGESTIONS = 'catalog-suggestions',
  CRAWL_RESULT = 'crawl-result',
  NO_CATALOG = 'no-catalog',
  NO_RESULTS = 'no-results',
}

export enum OutstandingSaveRequest {
  ADD_PRODUCT = 'add-product',
  UPDATE_PRODUCT = 'update-product',
  SORT_PRODUCTS = 'sort-products',
  REMOVE_PRODUCT = 'remove-product',
}

export enum TagLocation {
  NONE = 'none',
  SEARCH = 'search',
  SPATIAL = 'spatial',
}

export const MAX_NUM_CATALOG_SUGGESTIONS = 8;
export const MAX_NUM_PRODUCTS = 40;

export const uiaProductPrefix: TrackingIdPrefix = 'uia-product-';
export const uiaProductEditorPrefix: TrackingIdPrefix = 'uia-product-editor-';

export const UiaProductTrackingIds = {
  BULK_REMOVE_PRODUCTS_BUTTON: `${uiaProductPrefix}bulk-remove-products-button`,
  BULK_SELECT_PRODUCT: `${uiaProductPrefix}bulk-select-product`,
  BULK_TAG_PRODUCTS_BUTTON: `${uiaProductPrefix}bulk-tag-products-button`,
  CATALOG_CLIENT_DROPDOWN: `${uiaProductEditorPrefix}catalog-client-dropdown`,
  CLOSE_SKU_LIMIT_MODAL_BUTTON: `${uiaProductEditorPrefix}close-sku-limit-modal-button`,
  CONFIRM_BULK_REMOVE_PRODUCTS_BUTTON: `${uiaProductPrefix}confirm-bulk-remove-products-button`,
  CONNECT_CATALOG_LINK: `${uiaProductPrefix}connect-catalog-link`,
  CREATE_URL_TAG_BUTTON: `${uiaProductPrefix}create-url-tag-button`,
  OPEN_SKU_LIMIT_MODAL_BUTTON: `${uiaProductEditorPrefix}open-sku-limit-modal-button`,
  PRODUCT_DESTINATION_URL_LINK: `${uiaProductPrefix}product-destination-url-link`,
  PRODUCT_EDITOR_BASE_URL_TEXT_INPUT: `${uiaProductEditorPrefix}base-url-text-input`,
  PRODUCT_EDITOR_CANCEL_BUTTON: `${uiaProductEditorPrefix}cancel-button`,
  PRODUCT_EDITOR_CONFIGURE_TRACKING_PARAMS_LINK: `${uiaProductEditorPrefix}configure-tracking-params-link`,
  PRODUCT_EDITOR_EDIT_PRODUCT_NAME: `${uiaProductEditorPrefix}edit-product-name`,
  PRODUCT_EDITOR_EDIT_URL_TRACKING_PARAMS: `${uiaProductEditorPrefix}edit-url-tracking-params`,
  PRODUCT_EDITOR_ERROR_ALERT: `${uiaProductEditorPrefix}error-alert`,
  PRODUCT_EDITOR_IMAGE_CAROUSEL_NEXT_BUTTON: `${uiaProductEditorPrefix}image-carousel-next-button`,
  PRODUCT_EDITOR_IMAGE_CAROUSEL_PREV_BUTTON: `${uiaProductEditorPrefix}image-carousel-prev-button`,
  PRODUCT_EDITOR_LEARN_MORE_LINK: `${uiaProductEditorPrefix}learn-more-link`,
  PRODUCT_EDITOR_PDP_URL_TEXT_INPUT: `${uiaProductEditorPrefix}pdp-url-text-input`,
  PRODUCT_EDITOR_SAVE_BUTTON: `${uiaProductEditorPrefix}save-button`,
  PRODUCT_EDITOR_TRACKING_PARAMS_EDITOR_GOOGLE_REFERRAL_PARAM_DROPDOWN: `${uiaProductEditorPrefix}tracking-params-editor-google-referral-param-dropdown`,
  PRODUCT_EDITOR_TRACKING_PARAMS_EDITOR_INPUT: `${uiaProductEditorPrefix}tracking-params-editor-input`,
  PRODUCT_EDITOR_TRACKING_PARAMS_EDITOR_RECENT_PARAM_SUGGESTION: `${uiaProductEditorPrefix}tracking-params-editor-recent-param-suggestion`,
  PRODUCT_EDITOR_UPDATE_URL_BUTTON: `${uiaProductEditorPrefix}update-url-button`,
  PRODUCT_EDITOR_UPLOAD_PRODUCT_IMAGE: `${uiaProductEditorPrefix}upload-product-image`,
  PRODUCT_EDITOR_WARNING_ALERT: `${uiaProductEditorPrefix}warning-alert`,
  PRODUCT_SEARCH_BAR: `${uiaProductPrefix}product-search-bar`,
  PRODUCT_SECTION_CLOSE_BUTTON: `${uiaProductPrefix}product-section-close-button`,
  SINGLE_SELECT_PRODUCT: `${uiaProductPrefix}single-select-product`,
} as const satisfies Record<string, TrackingId>;

export const CRAWL_PRODUCT_TYPES: ProductType[] = ['Crawl', 'UpdateCrawl'];

export const BV_PRODUCT_PREFIX = 'bv_';

export const ProductValidationErrors = {
  MissingImageOrName: 'To save, all products need images and names.',
  InvalidUrl: 'To save, all product URLs must be valid.',
};

export const CONFIGURE_CATALOG_LINK =
  'https://developers.bazaarvoice.com/v1.0-SocialCommerceAPI/docs/configuring-product-catalog';

export enum DistributionTouchpoint {
  CuralateTouchpoint = 'curalate_touchpoint',
}

export const SEARCH_DEBOUNCE_DELAY = 300;
